import React from "react";
import { useTranslation } from "react-i18next";

function CookiePolicy() {

  const { t } = useTranslation();

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "auto" }}>

      <h1>{t("cookie.title")}</h1>

      <p>{t("cookie.intro")}</p>

      <h2>{t("cookie.whatTitle")}</h2>
      <p>{t("cookie.whatDesc")}</p>

      <h2>{t("cookie.typesTitle")}</h2>

      <h3>{t("cookie.necessaryTitle")}</h3>
      <p>{t("cookie.necessaryDesc")}</p>

      <ul>
        <li>{t("cookie.session")}</li>
        <li>{t("cookie.security")}</li>
        <li>{t("cookie.payment")}</li>
      </ul>

      <h3>{t("cookie.preferenceTitle")}</h3>
      <p>{t("cookie.preferenceDesc")}</p>

      <ul>
        <li>{t("cookie.language")}</li>
      </ul>

      <h3>{t("cookie.analyticsTitle")}</h3>
      <p>{t("cookie.analyticsDesc")}</p>

      <h2>{t("cookie.manageTitle")}</h2>
      <p>{t("cookie.manageDesc")}</p>

      <h2>{t("cookie.changesTitle")}</h2>
      <p>{t("cookie.changesDesc")}</p>

      <p>{t("cookie.contact")}</p>

    </div>
  );
}

export default CookiePolicy;